import Vue from "vue";
import VueRouter from "vue-router";
import ThePlayer from "../views/ThePlayer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "player",
    component: ThePlayer,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
